<template>
  <div class="user-info">
    <md-popup
      v-model="dialogVisible"
      @hide="hideDialog"
      :mask-closable="false"
      class="info-dialog"
    >
      <div class="close-icon" @click="hideDialog">
        <md-icon name="close"></md-icon>
      </div>
      <div class="title">{{ $t('title') }}</div>
      <div class="subtitle">{{ $t('subTitle') }}</div>
      <div class="form">
        <div class="section-header">{{ $t('basicInfo') }}</div>
        <div class="form-section">
          <!--<div class="form-group">-->
          <!--<div class="form-label">{{ $t('name') }}</div>-->
          <!--<md-input-item-->
          <!--ref="name"-->
          <!--name="name"-->
          <!--class="bordered"-->
          <!--v-model="form.name"-->
          <!--type="text"-->
          <!--readonly-->
          <!--v-validate="'required'"-->
          <!--:error="errors.first('name')"-->
          <!--&gt;-->
          <!--</md-input-item>-->
          <!--</div>-->
          <!--<div class="form-group">-->
          <!--<div class="form-label">{{ $t('nik') }}</div>-->
          <!--<md-input-item-->
          <!--ref="nik"-->
          <!--name="nik"-->
          <!--class="bordered"-->
          <!--v-model="form.nik"-->
          <!--type="digit"-->
          <!--readonly-->
          <!--v-validate="'required'"-->
          <!--:error="errors.first('nik')"-->
          <!--&gt;-->
          <!--</md-input-item>-->
          <!--</div>-->
          <div class="form-group">
            <div class="form-label">{{ $t('email') }}</div>
            <md-input-item
              ref="email"
              name="email"
              class="bordered"
              v-model="form.email"
              type="text"
              :placeholder="$t('emailPlaceholder')"
              v-validate="'required|email|max:80'"
              :error="errors.first('email')"
            >
            </md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label">{{ $t('gender') }}</div>
            <div>
              <md-radio name="MALE" v-model="form.gender" :label="$t('male')" inline/>
              <md-radio name="FEMALE" v-model="form.gender" :label="$t('female')" inline/>
            </div>
          </div>
        </div>
        <div class="section-header">{{ $t('address') }}</div>
        <div class="form-section">
          <div class="form-group">
            <div class="form-label">Province</div>
            <md-input-item
              ref="province"
              name="province"
              class="bordered"
              v-model="form.province"
              type="text"
              v-validate="'required|max:30'"
              :error="errors.first('province')"
            >
            </md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label">City</div>
            <md-input-item
              ref="city"
              name="city"
              class="bordered"
              v-model="form.city"
              type="text"
              v-validate="'required|max:30'"
              :error="errors.first('city')"
            >
            </md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label">District</div>
            <md-input-item
              ref="district"
              name="district"
              class="bordered"
              v-model="form.district"
              type="text"
              v-validate="'required|max:30'"
              :error="errors.first('district')"
            >
            </md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label">{{ $t('address') }}</div>
            <md-input-item
              ref="address"
              name="address"
              class="bordered"
              v-model="form.address"
              type="text"
              v-validate="'required|max:50'"
              :error="errors.first('address')"
            >
            </md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label">{{ $t('postCode') }}</div>
            <md-input-item
              ref="postCode"
              name="postCode"
              class="bordered"
              v-model="form.postCode"
              type="digit"
              v-validate="'required|max:10'"
              :error="errors.first('postCode')"
            >
            </md-input-item>
          </div>
        </div>
        <div class="section-header">{{ $t('birthInfo') }}</div>
        <div class="form-section">
          <div class="form-group">
            <div class="form-label">{{ $t('birthDate') }}</div>
            <md-input-item
              ref="birthDate"
              name="birthDate"
              v-model="form.birthDate"
              @click.native="isDatePickerShow = true"
              class="bordered has-slot birth-date-picker"
              readonly
              :placeholder="$t('birthDatePlaceholder')"
              v-validate="'required'"
              :error="errors.first('birthDate')"
            >
              <md-icon name="calendar" slot="left"></md-icon>
            </md-input-item>
            <div class="birth-date" v-dom-portal>
              <md-date-picker
                ref="datePicker"
                v-model="isDatePickerShow"
                type="custom"
                title="Choose a Day"
                :min-date="minDate"
                :text-render="dateRender"
                :custom-types="['dd', 'MM','yyyy']"
                :unit-text="['','','']"
                :default-date="currentDate"
                @change="onDatePickerChange"
                @confirm="onDatePickerConfirm"
                ok-text="Confirm"
                cancel-text="Cancel"
              ></md-date-picker>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">{{ $t('birthPlace') }}</div>
            <md-input-item
              ref="birthPlace"
              name="birthPlace"
              class="bordered"
              v-model="form.birthPlace"
              type="text"
              v-validate="'required|max:30'"
              :error="errors.first('birthPlace')"
            >
            </md-input-item>
          </div>
        </div>
      </div>
      <div class="section-header">{{ $t('other') }}</div>
      <div class="form-section">
        <div class="form-group">
          <div class="form-label">{{ $t('photo') }}</div>
          <div class="upload-area">
            <img v-if="imageUrl" :src="imageUrl" class="image-display">
            <md-image-reader
              name="photo"
              @select="onReaderSelect"
              @complete="onReaderComplete"
              @error="onReaderError"
              size="5000"
              :mime="['jpeg', 'png']"
            ></md-image-reader>
            <div class="upload-lead">
              <md-icon name="camera" size="md" color="#CCC"></md-icon>
            </div>
          </div>
          <div class="upload-tip">{{ $t('uploadTip') }}</div>
        </div>
      </div>
      <div class="submit-btn">
        <button-primary :loading="loading" type="primary" @click="handleSubmit">
          {{ $t('confirm') }}
        </button-primary>
      </div>
    </md-popup>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialog'
import { Button, DatePicker, Field, Icon, InputItem, ImageReader, Popup, Radio } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        title: 'Fill in the information',
        subTitle: 'According to OJK requirements, an electronic contract is required for funding. Please complete the following information',
        basicInfo: 'Basic Information',
        name: 'Name',
        nik: 'No KTP',
        email: 'E-mail',
        emailPlaceholder: 'Used to receive verification codes',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        province: 'Province',
        city: 'City',
        district: 'Sub-District',
        town: 'Urban Village',
        address: 'Address',
        postCode: 'Postal Code',
        birthInfo: 'Birth Information',
        birthDate: 'Date of Birth',
        birthDatePlaceholder: 'Pleace choose a date',
        birthPlace: 'Place of Birth',
        other: 'Other',
        photo: 'Selfie Photo',
        uploadTip: 'Please upload a clear face photo for identity verification',
        confirm: 'Confirm',
      },
      id: {
        title: 'Isi informasi',
        subTitle: 'Menurut persyaratan OJK, kontrak elektronik diperlukan untuk pendanaan. Silakan lengkapi informasi berikut',
        basicInfo: 'Informasi Dasar',
        name: 'Nama',
        nik: 'No KTP',
        email: 'E-mail',
        emailPlaceholder: 'Digunakan untuk menerima kode verifikasi',
        gender: 'Jenis Kelamin',
        male: 'Laki-laki',
        female: 'Perempuan',
        province: 'Provinsi',
        city: 'Kota',
        district: 'Kecamatan',
        town: 'Kelurahan',
        address: 'Alamat',
        postCode: 'Kode Pos',
        birthInfo: 'Informasi Kelahiran',
        birthDate: 'Tanggal Lahir',
        birthDatePlaceholder: 'Pleace choose a date',
        birthPlace: 'Tempat Lahir',
        other: 'Lainnya',
        photo: 'Foto Selfie',
        uploadTip: 'Unggah foto wajah yang jelas untuk verifikasi identitas',
        confirm: 'Konfirmasi',
      },
    },
  },
  mixins: [
    dialogMixin,
  ],
  components: {
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [ImageReader.name]: ImageReader,
    [InputItem.name]: InputItem,
    [Popup.name]: Popup,
    [Radio.name]: Radio,
  },
  data() {
    const userInfo = this.$store.state.userInfo
    return {
      form: {
        name: userInfo.fullName,
        nik: userInfo.credentialNumber,
        email: userInfo.email || '',
        gender: 'MALE',
        province: '',
        city: '',
        district: '',
        address: '',
        postCode: '',
        birthDate: '',
        birthPlace: '',
        image: '',
      },
      imageUrl: '',
      currentDate: new Date(),
      isDatePickerShow: false,
      minDate: new Date('1900/1/1'),
      loading: false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  methods: {
    onReaderSelect(name, { files }) {
      this.$toast.loading('loading...')
    },
    async onReaderComplete(name, { dataUrl, file }) {
      await this.uploadImage({ file: file })
      this.$toast.hide()
    },
    onReaderError(name, { msg }) {
      this.$toast.failed(msg)
    },
    async uploadImage(data) {
      try {
        const formData = new FormData()
        formData.append('file', data.file)
        const response = await this.$http.post('/file/upload/self-photo', formData)
        const [imageName] = Object.keys(response.data.data)
        this.form.image = imageName
        const [imageUrl] = Object.values(response.data.data)
        this.imageUrl = imageUrl
      } catch (error) {
        console.log(error)
      } finally {
        this.$toast.hide()
      }
    },
    onDatePickerChange() {
    },
    onDatePickerConfirm() {
      this.form.birthDate = this.$refs.datePicker.getFormatDate('dd-MM-yyyy')
    },
    dateRender() {
      // const args = Array.prototype.slice.call(arguments)
      // const typeFormat = args[0] // 类型
      // const column0Value = args[1] // 第1列选中值
      // const column1Value = args[2] // 第2列选中值
      // const column2Value = args[3] // 第3列选中值
    },
    async handleSubmit() {
      const valid = await this.$validator.validate()
      if (!valid) return
      try {
        this.loading = true
        const payload = {
          email: this.form.email,
          gender: this.form.gender,
          province: this.form.province,
          city: this.form.city,
          districtOne: this.form.district,
          address: this.form.address,
          postCode: this.form.postCode,
          birthDate: this.form.birthDate,
          birthPlace: this.form.birthPlace,
          selfFileName: this.form.image,
        }
        const response = await this.$http.post('/digitsign/register', payload)
        const { code } = response.data
        if (code === 'SUCCESS') {
          this.hideDialog()
          this.$emit('DSRegistCompleted')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.user-info /deep/ {
  .md-popup-box {
    width 90%
    max-height 80vh
    overflow-y auto
    padding 20px
    background-color #fff
    border-radius 6px
  }
}

.close-icon
  position absolute
  top 10px
  right 15px

.title
  margin 20px auto 10px
  text-align center
  font-weight bold
  font-size 18px

.subtitle
  margin-bottom 20px
  text-align center
  font-size 12px
  line-height 16px

.section-header
  font-weight 500
  margin-bottom 15px
  font-size 16px

.form-section
  margin-bottom 20px

.form-group
  margin-bottom 16px
  .form-label
    margin-bottom 8px
    color #555
    font-size 12px

.birth-date-picker
  .md-icon
    margin-left 10px
  ::-webkit-input-placeholder {
    margin 0
    padding 0
  }
  ::-moz-placeholder {
    line-height 14px
  }
  :-ms-input-placeholder {
    line-height 10px
  }

.birth-date /deep/ {
  .md-popup {
    z-index 9999999
  }
}

.upload-area
  position: relative
  height 150px
  border 1px solid #eee
  .image-display
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    width 100%
    height 100%

  .upload-lead
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    display flex
    justify-content center
    align-items center
    z-index 2

.upload-tip
  margin 5px 0
  font-size 10px
  color #666

.submit-btn
  margin 20px auto
</style>
